import notification from '@/assets/notification/faliurnotification.mp3'

export default {
  methods: {
    ringErrorBell() {
      const audio = new Audio(notification)
      audio.play()
    },
  },
}
